import { WritableDraft } from "immer";
import isNil from "lodash/isNil";
import map from "lodash/map";
import some from "lodash/some";
import values from "lodash/values";
import { FiltersV2State } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { resetFilterValues } from "PFApp/components/filters_v2/stores/filters_v2_store/mutators/reset_values";
import { updateFilter } from "PFApp/components/filters_v2/stores/filters_v2_store/mutators/update_filter";
import { FilterV2 } from "PFTypes/filters_v2";

export const resetScope = (draftState: WritableDraft<FiltersV2State>, updatedFilters: FilterV2[]) => {
  if (isNil(draftState.scope)) {
    return;
  }

  // if any filter without limit was updated then information about scope is not valid anymore
  if (some(updatedFilters, ({ limit }) => isNil(limit))) {
    draftState.scope = Infinity;
  }
};

export const validateFiltersScopeLimit = (draftState: WritableDraft<FiltersV2State>) => {
  if (isNil(draftState.scope)) {
    return;
  }

  const filtersWithLimit = [
    ...values(draftState.mainFilters).filter(({ limit }) => !isNil(limit)),
    ...values(draftState.childrenFilters).filter(({ limit }) => !isNil(limit))
  ];

  if (filtersWithLimit.length === 0) {
    return;
  }

  const filtersToExclude = filtersWithLimit.filter(({ limit }) => limit! < draftState.scope!);

  if (filtersToExclude.length === 0) {
    return;
  }

  draftState.filtersExcludedByScope = map(filtersToExclude, ({ value, originalPath, isChildren, limit }) => ({
    value,
    originalPath,
    limit: limit!,
    isChildren
  }));

  resetFilterValues(draftState, { subset: map(filtersToExclude, "name") });
};

export const updateScope = (draftState: WritableDraft<FiltersV2State>, scope?: number | null) => {
  draftState.scope = scope;
  if (isNil(scope) || draftState.filtersExcludedByScope.length === 0) {
    return;
  }

  const filtersToReestablish = draftState.filtersExcludedByScope.filter(({ limit }) => limit >= scope);

  draftState.filtersExcludedByScope = [];

  filtersToReestablish.forEach((filter) => updateFilter(draftState, filter));
};
